<template>
  <v-card flat>
    <v-toolbar color="#ffd504">
      <v-toolbar-title>
        <img
          src="https://storage.googleapis.com/v4-weserve/logo/logo_email.png"
          width="200px"
          class="mt-2 mr-3"
        />
        <span class="black--text text-select-province mt-2">Receipt</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text height="900px">
      <v-layout justify-center style="font-size: 16px">
        <v-flex xs12 class="text-xs-center mt-5" v-if="loading == true">
          <img
            src="./../../../assets/back-office/food_loaing.gif"
            width="180px"
          />
          <br />
          <span style="font-size: 30px; font-weight: bold">Loading..</span>
        </v-flex>
        <v-flex xs8 v-else>
          <table
            width="100%"
            v-for="(store_info, index) in dataOrder.order_store"
            :key="index"
          >
            <tr align="center">
              <td>
                <h1 class="my-3">WESERVE Food Delivery Order</h1>
              </td>
            </tr>

            <tr>
              <td class="layout-padding">
                เรียน {{ store_info.store_name }} <br />WESERVE Food Delivery
                ขอเรียนให้ทราบว่า ท่านได้รับการสั่งซื้อรายการอาหารครั้งล่าสุด
                <br />
                เมื่อวันที่ {{ dataOrder.order_time_start.substring(0, 10) }} ณ
                เวลา {{ dataOrder.order_time_start.substring(11, 16) }} น.
                โดยมีการทำรายการดังนี้
              </td>
            </tr>

            <tr>
              <td class="layout-padding">
                <table
                  width="100%"
                  style="background-color: #eeeeee"
                  class="my-3"
                >
                  <tbody>
                    <tr>
                      <td width="15%">เลขที่ :</td>
                      <td colspan="3" width="85%">
                        {{ dataOrder.order_code }}
                      </td>
                    </tr>

                    <tr>
                      <td width="15%">ที่อยู่ผู้รับ :</td>
                      <td colspan="3" width="85%">
                        {{
                          dataOrder.order_customer_address.customer_address_text
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="layout-padding">
                <table width="100%">
                  <tbody>
                    <tr>
                      <th>รายละเอียด</th>
                      <th class="text-xs-left">คำขอพิเศษ</th>
                      <th>ราคา</th>
                      <th>จำนวน</th>
                      <th>รวม</th>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <hr />
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index_item) in filteredProductv(store_info)"
                      :key="index_item"
                    >
                      <td width="35%">
                        <h4 class="mt-2">
                          {{ item.order_detail_product.product_name_th }}
                        </h4>
                        <div
                          v-if="item.order_detail_product.product_name_en != ''"
                          class="name-eng"
                        >
                          {{ item.order_detail_product.product_name_en }}
                        </div>
                        <ul
                          style="margin: 0"
                          v-for="option_info in item.order_detail_order_option"
                          :key="option_info.order_option_id"
                        >
                          <li
                            v-for="choice_info in option_info
                              .order_option_option_choice.option_choice"
                            :key="choice_info.choice_id"
                          >
                            Option
                            {{
                              option_info.order_option_option_choice
                                .option_name_th
                            }}
                            - {{ choice_info.choice_name_th }} ฿{{
                              choice_info.choice_price
                            }}
                          </li>
                          <div
                            v-for="choice_info in option_info
                              .order_option_option_choice.option_choice"
                            :key="choice_info.choice_id"
                            class="name-eng"
                          >
                            <span
                              v-if="
                                option_info.order_option_option_choice
                                  .option_name_en != null &&
                                choice_info.choice_name_en != null
                              "
                              >Option
                              {{
                                option_info.order_option_option_choice
                                  .option_name_en
                              }}
                              - {{ choice_info.choice_name_en }}</span
                            >
                          </div>
                        </ul>
                      </td>
                      <td
                        width="20%"
                        style="vertical-align: top; padding-top: 10px"
                      >
                        {{ item.order_detail_product.product_note }}
                      </td>
                      <td
                        align="center"
                        width="15%"
                        style="vertical-align: top; padding-top: 10px"
                      >
                        {{
                          parseFloat(
                            item.order_detail_product_seller_price
                          ).toFixed(2)
                        }}
                      </td>
                      <td
                        align="center"
                        width="10%"
                        style="vertical-align: top; padding-top: 10px"
                      >
                        {{ item.order_detail_amount }}
                      </td>
                      <td
                        align="right"
                        width="20%"
                        style="vertical-align: top; padding-top: 10px"
                      >
                        {{
                          parseFloat(
                            item.order_detail_total_product_price
                          ).toFixed(2)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        <hr />
                      </td>
                    </tr>
                    <tr align="right">
                      <td colspan="4">Vat :</td>
                      <td colspan="2">
                        {{ parseFloat(dataOrder.order_vat_price).toFixed(2) }}
                      </td>
                    </tr>
                    <tr align="right">
                      <td colspan="4">Service charge :</td>
                      <td colspan="2">
                        {{
                          parseFloat(
                            dataOrder.order_service_charge_price
                          ).toFixed(2)
                        }}
                      </td>
                    </tr>
                    <tr align="right">
                      <td colspan="4">Total :</td>
                      <td colspan="2" class="subtotal">
                        {{ calStorePrice(store_info) }}
                      </td>
                    </tr>
                    <tr align="right">
                      <td colspan="4">Store note :</td>
                      <td colspan="2">{{ store_info.store_note }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { backendVersion } from "@/axios-path";
export default {
  data() {
    return {
      dataOrder: {},
      loading: false,
    };
  },
  watch: {
    dialog() {},
  },
  methods: {
    filteredProductv(store_info) {
      return this.dataOrder.order_detail.filter((val) => {
        return val.order_detail_store_id == store_info.store_id;
      });
    },
    calStorePrice(store_info) {
      let price = 0;
      for (let val of this.dataOrder.order_detail) {
        if (val.order_detail_store_id == store_info.store_id) {
          price = price + val.order_detail_total_product_price;
        }
      }
      return price.toFixed(2);
    },
  },
  async created() {
    this.loading = true;
    let API_param = await this.$store.dispatch(
      "fetchGeneral/coreInstanceGetData",
      backendVersion.version +
        "/service/GetServiceDiscovery/" +
        this.$route.params.province +
        "/web_back_office"
    );
    this.dataOrder = await this.$store.dispatch(
      "fetchOrderDetailBack/getOrderDetailReceipt",
      API_param.fetchOrderDetailBack_getOrderDetail + this.$route.params.orderid
    );
    this.loading = false;
  },
};
</script>
<style scoped>
.name-eng {
  color: grey;
  line-height: 13px;
  /* margin-bottom: 10px; */
  font-size: 13px;
}
</style>

